import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { Admin } from "@/savaradio/common"
export const initialLoading = {
  create: false,
  delete: false,
  update: false,
  get: false,
  find: false,
  upload: false
}
export type IsLoading = Record<keyof typeof initialLoading, boolean>

const initialState: { value: Admin[] | null, isLoading: IsLoading } = {
  value: null, isLoading: initialLoading
}

const adminSlice = createSlice({
  name: "admin_slice",
  initialState,
  reducers: {
    append: (state, action: PayloadAction<Admin>) => {
      if (!state.value) state.value = [action.payload]
      if (
        state.value &&
        !state.value.some(item => item._id === action.payload._id)
      ) state.value = [action.payload, ...state.value]
    },
    reset: (state, action: PayloadAction<Admin[] | null>) => {
      state.value = action.payload
    },
    merge: (state, action: PayloadAction<Admin>) => {
      if (state.value) state.value = state.value.map(admin => {
        if (admin._id === action.payload._id) return action.payload
        return admin
      })
    },
    pop: (state, action: PayloadAction<Admin>) => {
      if (state.value) state.value = state.value.filter(admin => admin._id !== action.payload._id)
    },
    setLoading: (state, action: PayloadAction<Partial<IsLoading>>) => {
      state.isLoading = {
        ...state.isLoading,
        ...action.payload
      }
    }
  }
})

export const { append, reset, pop, merge, setLoading } = adminSlice.actions
export const admin_slice = adminSlice.reducer